import App from 'base-shell/lib';
import { Component } from 'react';

import LiffProvider from 'providers/Liff';

import { clientLiffId, stage } from 'config/const';
import _config from './config';

import 'styles/index.css';
import 'styles/quill.css';

// ReactGA.initialize(GaMeasurementId);

export default class TagHeuerClientApp extends Component {
  render() {
    return (
      <LiffProvider
        liffId={clientLiffId}
        mock={stage === 'local' ? require('config/mock').liff : undefined}
      >
        <App config={_config} />
      </LiffProvider>
    );
  }
}
